import comprasSeguimientoService from '../services/comprasSeguimientoService';
import { RemitoCompra, RemitoCompraDetalle } from '../services/remitoCompraService';

export type RemitoPuedeAnularResult =
  | { puedeAnular: true }
  | { puedeAnular: false; motivo: string };

export type RemitoDetalleAnular = Pick<
  RemitoCompraDetalle,
  'nroItem' | 'nroFormularioMaster' | 'nroItemMaster'
>;

const MOTIVO_HILO =
  'No se puede anular: hay facturas u otros comprobantes asociados al ítem master';

/** Anulado: nombre/comprobante ANULADO o asentado A (según GET). */
export function esRemitoCompraAnulado(remito: Pick<RemitoCompra, 'nombre' | 'asentado' | 'nroRemito'>): boolean {
  const nombre = (remito.nombre ?? '').trim().toUpperCase();
  const asentado = String(remito.asentado ?? '').trim().toUpperCase();
  const comprobante = String(remito.nroRemito ?? '').trim().toUpperCase();
  return nombre === 'ANULADO' || asentado === 'A' || comprobante.includes('ANULADO');
}

/** Ítem master de este remito: master apunta al propio formulario e ítem. */
export function esItemMasterDelRemito(
  nroFormulario: number,
  item: RemitoDetalleAnular,
): boolean {
  const form = Number(nroFormulario);
  const masterForm = Number(item.nroFormularioMaster);
  const masterItem = Number(item.nroItemMaster);
  const nroItem = Number(item.nroItem);
  return (
    Number.isFinite(form) &&
    form > 0 &&
    masterForm === form &&
    Number.isFinite(nroItem) &&
    masterItem === nroItem
  );
}


export async function remitoPuedeAnular(
  nroFormulario: number,
  detalles: RemitoDetalleAnular[] | null | undefined,
): Promise<RemitoPuedeAnularResult> {
  const items = detalles ?? [];
  const masters = items.filter((d) => esItemMasterDelRemito(nroFormulario, d));
  if (masters.length === 0) {
    return { puedeAnular: true };
  }

  const seen = new Set<string>();
  const claves: Array<{ form: number; item: number }> = [];
  for (const m of masters) {
    const form = Number(m.nroFormularioMaster);
    const item = Number(m.nroItemMaster);
    const key = `${form}-${item}`;
    if (seen.has(key)) continue;
    seen.add(key);
    claves.push({ form, item });
  }

  const hilos = await Promise.all(
    claves.map(async ({ form, item }) => {
      try {
        return await comprasSeguimientoService.getHilo(form, item);
      } catch {
        return null;
      }
    }),
  );

  const esteFormulario = Number(nroFormulario);
  for (const h of hilos) {
    if (h == null) continue;
    for (const c of h.comprobantes || []) {
      const otro = Number(c.nroFormulario);
      if (!Number.isFinite(otro) || otro <= 0) continue;
      if (otro !== esteFormulario) {
        return { puedeAnular: false, motivo: MOTIVO_HILO };
      }
    }
  }

  return { puedeAnular: true };
}
